import React from 'react';
import I18n from 'app/i18n';
import {
    ExternalAuthFlowOptions,
    PendingLinkResponse,
    showExternalAuthError,
    showExternalLinkConfirmation,
    showExternalRegistrationSuccess,
    startExternalAuthFlow
} from 'app/utils/externalAuth';

const REGISTRATION_ERROR_KEYS = [
    'battlenet_id_required',
    'battlenet_already_linked',
    'failed_to_authenticate',
    'battlenet_unavailable'
];

const LINK_ERROR_KEYS = [
    'failed_to_link_account',
    'battlenet_already_linked',
    'user_already_linked',
    'battlenet_unavailable',
    'invalid_or_expired_link'
];

interface PendingBattlenetLink extends PendingLinkResponse {
    battlenet_id?: string
    battletag?: string | null
}

const renderPendingBattlenetLink = (data: PendingBattlenetLink): React.ReactNode => <>
    <p>{I18n.t('battlenet.labels.confirm_link_account')}</p>
    {data.battletag && <p><strong>{data.battletag}</strong></p>}
</>;

export const startBattlenetAuthFlow = (options?: ExternalAuthFlowOptions): void => startExternalAuthFlow(
    '/auth/battlenet',
    options
);

export const showBattlenetAuthError = (): void => showExternalAuthError('battlenet', REGISTRATION_ERROR_KEYS);

export const showBattlenetRegistrationSuccess = (): void => showExternalRegistrationSuccess('battlenet');

export const showBattlenetLinkConfirmation = (battlenetLinked: boolean): void => showExternalLinkConfirmation({
    errorKeys: LINK_ERROR_KEYS,
    linked: battlenetLinked,
    provider: 'battlenet',
    renderDetails: renderPendingBattlenetLink
});
